import type {
  ApiEntity,
  ComponentEntity,
  ResourceEntity,
} from '@backstage/catalog-model';
import type { BreadcrumbDefinition } from '@ipen-portal/plugin-navigation-react';

export const entitiesOfSameKindAndTypeAndSystem: BreadcrumbDefinition<
  ApiEntity | ComponentEntity | ResourceEntity
>['siblingsExtractor'] = entity =>
  (typeof entity.spec.system === 'string'
    ? {
        filter: {
          'kind': entity.kind,
          'spec.system': entity.spec.system,
          'spec.type': entity.spec.type,
        },
      }
    : null);
